/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconRoute2 = createReactComponent("route-2", "IconRoute2", [
  ["path", { d: "M3 19a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", key: "svg-0" }],
  ["path", { d: "M19 7a2 2 0 1 0 0 -4a2 2 0 0 0 0 4z", key: "svg-1" }],
  ["path", { d: "M14 5a2 2 0 0 0 -2 2v10a2 2 0 0 1 -2 2", key: "svg-2" }]
]);

export { IconRoute2 as default };
//# sourceMappingURL=IconRoute2.js.map
